<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
    <g id="Icon-MissionBuilder" transform="translate(-1285 -1400)">
      <g id="Group_602" transform="translate(1272 513)">
        <circle
          id="Ellipse_5"
          cx="17"
          cy="17"
          r="17"
          transform="translate(13 887)"
          :fill="color"
        />
      </g>
      <g id="Group_1014" transform="translate(27.508 1.049)">
        <path
          d="M2.758,6.951H0L5.517,0l5.515,6.949-2.756,0L5.517,3.475,2.758,6.951Z"
          transform="translate(1268.738 1408)"
          fill="none"
          stroke="#383935"
        />
        <path
          d="M2.758,6.951H0L5.517,0l5.515,6.949-2.756,0L5.517,3.475,2.758,6.951Z"
          transform="translate(1268.738 1414.951)"
          fill="none"
          stroke="#383935"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MissionsIconOutline',
  props: {
    color: {
      type: String,
      default: 'rgb(165, 216, 103)',
    },
  },
}
</script>

<style scoped>
svg {
  width: 34px;
  height: 34px;
}
</style>
